import {
  Card,
  CardContent,
  Container,
  Grid,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import Header from "components/Header";
import { DEVICE_DETAILS } from "config";
import TranslationProvider from "providers/TranslationProvider";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InboundSupplierVehicleForm } from "./InboundSupplierVehicleForm";
import { OutboundSupplierVehicleForm } from "./OutboundSupplierVehicleForm";
import { styled } from "@mui/system";
import { useSelector } from "react-redux";
import { updateLang } from "i18n";
import { useRemoteConfig } from "providers";
import { convertStringToArray } from "utils/rcUtils";

const StyledMainCard = styled(Card)({
  border: `1px solid #dadce0`,
  wordWrap: "break-word",
  pageBreakInside: "avoid",
  background: "#fff",
  borderRadius: 6,
  borderTopWidth: 10,
  borderTopColor: "#1976d2",
  marginTop: 10,
});

const VehicleChecklistForm = () => {
  const customers = useRemoteConfig("vehicleInspectionCustomers");
  const customerArray = customers ? convertStringToArray(customers) : [];
  const buildings = useRemoteConfig("vehicleInspectionBuildings");
  const buildingArray = buildings ? convertStringToArray(buildings) : [];
  console.log("jobDepartmentOptions", customerArray, buildingArray);
  const sortedCustomers = [...customerArray].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
  const sortedBuildings = [...buildingArray].sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: "base" })
  );
  const  customerOptions = sortedCustomers.map(customer => ({
    id: "1", value: customer, label: customer
  }));
  const  buildingOptions = sortedBuildings.map(building => ({
    id: "1", value: building, label: building
  }));
  console.log("jobDepartmentOptions", customerOptions, buildingOptions);
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (_, newValue) => {
    setActiveTab(newValue);
  };

  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnvironment = document.querySelector(".imtime-testEnvironment");
    if (header) {
      header.style.display = "none";
    }
    if (testEnvironment) {
      testEnvironment.style.display = "none";
    }
  }, []);

  const {version} = useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }

  return (
    <Container maxWidth="sm" disableGutters>
      <form noValidate autoComplete="off">
        <Grid container direction="column" alignItems="stretch" spacing={0}>
          <Grid item style={{maxWidth: '100%'}} >
            <TranslationProvider />
            <Header
              isLogoLinkDisabled={
                DEVICE_DETAILS.deviceType === "mobile" ? true : false
              }
            />
            <StyledMainCard>
              <CardContent sx={{padding: 0, paddingTop: "5px"}}>
                <Typography
                  variant="h6"
                  gutterBottom
                  color="textPrimary"
                  textAlign="center"
                >
                  {t("other.lblVehicleSupplierForms")}
                </Typography>
                <Grid display="flex" justifyContent="center" xs={12}>
                  <Tabs value={activeTab} onChange={handleTabChange}>
                    <Tab label={t("other.lblInbound")} />
                    <Tab label={t("other.lblOutbound")} />
                  </Tabs>
                </Grid>
              </CardContent>
              <CardContent style={{padding: 0}}>
                <Grid>
                  {activeTab === 0 ? (
                    <InboundSupplierVehicleForm inboundSupplierOptions={customerOptions} buildingOptions={buildingOptions} />
                  ) : (
                    <OutboundSupplierVehicleForm outboundSupplierOptions={customerOptions} buildingOptions={buildingOptions} />
                  )}
                </Grid>
              </CardContent>
            </StyledMainCard>
          </Grid>
        </Grid>
      </form>
    </Container>
  );
};

export default VehicleChecklistForm;
